import { gql } from '@apollo/client';

export const GET_EMAIL_CAMPAIGN_RESULT = gql`
    query GetEmailCampaignResult($campaignId: String!) {
        getEmailCampaignResult(campaignId: $campaignId) {
            campaignId
            status
            totalUsers
            emailsSent
            emailsFailed
            successRate
            startedAt
            completedAt
            errors
        }
    }
`;

